module.exports = __webpack_public_path__ + "static/media/Deino_gaussian2.1bae75eb.png";